import { Col, Row, Tabs } from 'antd';
import { useIntl } from 'react-intl';
import languageData from '../../../../../domain/core/AppLanguageSwitcher/data';
import LanguageCode from '../../../../../shared/services/types/language-code';
import type { TabsProps } from 'antd';
import ProductTagInfoStandard from './product-tag-info-standard';
import ProductTagInfoLanguage from './product-tag-info-language';
import MainUtils from 'src/shared/utils/main';
import { useLocaleContext } from 'src/domain/utility/AppContextProvider/LocaleContextProvide';

interface ICategoryInfoProps { }

const ProductTagInfo = (props: ICategoryInfoProps) => {
  const { messages } = useIntl();

  const { locale }: any = useLocaleContext();

  const langComponent = [
    {
      code: `${LanguageCode.English}`,
      langComponent: (
        <ProductTagInfoLanguage code={LanguageCode.English} index={0} />
      ),
    },
    {
      code: `${LanguageCode.Español}`,
      langComponent: (
        <ProductTagInfoLanguage index={1} code={LanguageCode.Español} />
      ),
    },
    {
      code: `${LanguageCode.Arabic}`,
      langComponent: (
        <ProductTagInfoLanguage index={2} code={LanguageCode.Arabic} />
      ),
    },
  ];

  const itemsTab: TabsProps['items'] = [
    {
      key: 'standard',
      label: `${messages['productTags.productTagInfo.standard'].toString()}`,
      children: (
        <ProductTagInfoStandard
          code={`${!MainUtils.isEmptyValue(locale.code)
              ? locale.code
              : LanguageCode.English
            }`}
        />
      ),
    },
    ...languageData
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((language) => {
        return {
          key: language.code,
          label: (
            <>
              <Row gutter={7}>
                <Col>
                  <i className={`flag flag-24 flag-${language.icon}`} />
                </Col>
                <Col>
                  <h4 className='title-tab'>{language.name}</h4>
                </Col>
              </Row>
            </>
          ),
          children: (
            <>
              {langComponent && langComponent?.length > 0 ? (
                langComponent?.find((item) => item.code === language.code)
                  ?.langComponent ?? <></>
              ) : (
                <></>
              )}
            </>
          ),
        };
      }),
  ];
  return <Tabs defaultActiveKey='standard' items={itemsTab} />;
};

export default ProductTagInfo;
